import { mapGetters } from 'vuex'
import { generateMetaInfo } from '../../common'

import Error from 'views/Error'
import Breadcrumbs from 'components/Breadcrumbs'
import Title from 'components/Title'
import FlexContent from 'components/FlexContent'
import HeroImage from 'components/HeroImage'
import Form from 'components/Form/Form'

export default {
  name: 'WildcardView',
  computed: {
    ...mapGetters(['loading', 'getPageBySlug', 'options', 'protected', 'pageAuthenticated']),
    page () {
      return this.getPageBySlug(this.$route.path)
    },
    pageTitle () {
      return this.page.page_title_override ? this.page.page_title_override : this.page.title.rendered
    },
    pageTitleWithLineBreaks () {
      if (this.page.has_custom_line_breaks) {
        return this.page.custom_line_breaks_repeater.map((x) => {
          return x.line
        }).join('&shy;')
      } else {
        return false
      }
    }
  },
  metaInfo () {
    const page = this.page
    return page ? generateMetaInfo(this.options, this.page) : {}
  },
  mounted () {
    this.setCurrentPage(this.page)
  },
  watch: {
    '$route': function () {
      this.setCurrentPage(this.page)
    },
    loading: function () {
      this.setCurrentPage(this.page)
    }
  },
  methods: {
    setCurrentPage (page) {
      this.$store.dispatch('setCurrentPage', page)
    },
    renderError () {
      // this.log('error occured')
      this.$store.dispatch('error', { error: { status: 404 }})
      return <Error />
    },
    renderPage () {
      // this.log(this.page)
      return (
        <div class='page'>
          {this.page.hero_image
            ? (<HeroImage imageUrl={this.page.hero_image.sizes.friwi_huge} />)
            : null
          }
          <Breadcrumbs page={this.page} />
          {this.pageTitleWithLineBreaks
            ? (<Title level={1} id={this.pageTitle} richText={this.pageTitleWithLineBreaks} modifiers={['no-hyphens']} />)
            : (<Title level={1} id={this.pageTitle}>{this.pageTitle}</Title>)
          }

          {this.protected && !this.pageAuthenticated
            ? <Form formEndpoint={''} buttonText={'Login'} isLogin={true} formFields={[{ label: 'Passwort', required: true, type: 'password' }]} />
            : this.page.c_flex_content && this.page.c_flex_content.length
              ? (<FlexContent componentData={this.page.c_flex_content} />)
              : null
          }
        </div>
      )
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  // beforeRouteUpdate (to, from, next) {
  //   // console.log(to)
  //   next()
  // },
  render (h) {
    const { loading, page } = this
    // this.log('page: ', page)
    return (
      loading ? 'Loading…' : (page
        ? this.renderPage()
        : this.renderError()
      )
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/Wildcard/index.js